/* ============================================================
   CAIROS v2 · comportamiento (tema Shopify)
   Vanilla, sin librerías. El contenido ya está en el DOM; esto
   añade movimiento, los interactivos y el carrito AJAX real.
   Datos de catálogo: window.CAIROS.perfumes (inyectado por Liquid).
   ============================================================ */
(function () {
  "use strict";

  var CAIROS = window.CAIROS || {};
  var WA = CAIROS.wa || "https://wa.me/34632990595";
  function perfumes() { return CAIROS.perfumes || []; }

  var finoPuntero = window.matchMedia("(pointer:fine)").matches;
  var reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;

  /* ---------- reveal on scroll ---------- */
  try {
    var obs = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("ver"); obs.unobserve(e.target); } });
    }, { threshold: .16, rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".rev, .mask, .capa").forEach(function (el) { obs.observe(el); });
  } catch (_) {
    document.querySelectorAll(".rev,.mask,.capa").forEach(function (el) { el.classList.add("ver"); });
  }

  /* ---------- cabecera que se esconde al bajar ---------- */
  var cab = document.querySelector(".cab"), y0 = 0;
  if (cab) window.addEventListener("scroll", function () {
    var y = window.scrollY;
    cab.classList.toggle("oculta", y > 240 && y > y0);
    y0 = y;
  }, { passive: true });

  /* ---------- menú móvil ---------- */
  var ham = document.querySelector(".icono-menu");
  if (ham) ham.addEventListener("click", function () {
    var m = document.querySelector(".menu");
    if (!m) return;
    var ab = m.classList.toggle("menu-abierto");
    document.body.style.overflow = ab ? "hidden" : "";
  });

  /* ---------- HERO entrada ---------- */
  (function () {
    var hero = document.querySelector(".hero"); if (!hero) return;
    setTimeout(function () { hero.classList.add("entrado"); }, 90);
  })();

  /* ---------- parallax (hero bg + [data-par]) ---------- */
  (function () {
    if (reduce) return;
    var bg = document.querySelector(".hero-fondo img");
    var pars = [].slice.call(document.querySelectorAll("[data-par]"));
    if (!bg && !pars.length) return;
    var ticking = false;
    function upd() {
      var y = window.scrollY;
      if (bg) bg.style.transform = "translateY(" + (y * 0.28) + "px)";
      pars.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        var v = parseFloat(el.getAttribute("data-par")) || 0.12;
        el.style.transform = "translateY(" + (centro * -v) + "px)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () { if (!ticking) { requestAnimationFrame(upd); ticking = true; } }, { passive: true });
    upd();
  })();

  /* ---------- cursor personalizado (solo escritorio) ---------- */
  (function () {
    if (!finoPuntero) return;
    var aro = document.createElement("div"); aro.className = "cursor";
    var pto = document.createElement("div"); pto.className = "cursor-punto";
    document.body.appendChild(aro); document.body.appendChild(pto);
    document.body.classList.add("cursor-on");
    var x = innerWidth / 2, y = innerHeight / 2, ax = x, ay = y;
    document.addEventListener("mousemove", function (e) {
      x = e.clientX; y = e.clientY;
      pto.style.transform = "translate(" + x + "px," + y + "px) translate(-50%,-50%)";
    });
    (function bucle() {
      ax += (x - ax) * .18; ay += (y - ay) * .18;
      aro.style.transform = "translate(" + ax + "px," + ay + "px) translate(-50%,-50%)";
      requestAnimationFrame(bucle);
    })();
    document.querySelectorAll("a,button,.opcion,.tarjeta,.ia-chip").forEach(function (el) {
      el.addEventListener("mouseenter", function () { aro.classList.add("crece"); });
      el.addEventListener("mouseleave", function () { aro.classList.remove("crece"); });
    });
  })();

  /* ---------- botones magnéticos (solo escritorio) ---------- */
  (function () {
    if (!finoPuntero || reduce) return;
    document.querySelectorAll(".mag").forEach(function (b) {
      b.addEventListener("mousemove", function (e) {
        var r = b.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) * .3, dy = (e.clientY - (r.top + r.height / 2)) * .4;
        b.style.transform = "translate(" + dx + "px," + dy + "px)";
      });
      b.addEventListener("mouseleave", function () { b.style.transform = ""; });
    });
  })();

  /* ---------- asesor "encuentra tu firma" ---------- */
  (function () {
    var raiz = document.getElementById("asesor"); if (!raiz) return;
    var resp = {}, paso = 0;
    function pinta() {
      raiz.querySelectorAll(".paso").forEach(function (p) { p.classList.toggle("activo", +p.dataset.paso === paso); });
      raiz.querySelectorAll(".punto").forEach(function (d, n) { d.classList.toggle("on", n <= paso); });
      var pr = raiz.querySelector(".progreso"); if (pr) pr.style.visibility = paso === 3 ? "hidden" : "visible";
    }
    function recomienda() {
      var lista = perfumes();
      if (!lista.length) return;
      var cand = lista.filter(function (p) {
        return resp.genero === "unisex" || p.genero === "unisex" || p.genero === resp.genero;
      });
      if (!cand.length) cand = lista;
      var mejor = null, tope = -1;
      cand.forEach(function (p) {
        var n = 0;
        if (p.genero === resp.genero) n += 2;
        if (resp.momento === "todo" || p.momento === resp.momento || p.momento === "todo") n += 2;
        if (p.familia === resp.familia) n += 5;
        if (n > tope) { tope = n; mejor = p; }
      });
      if (!mejor) mejor = lista[0];
      var g = { hombre: "para él", mujer: "para ella", unisex: "de regalo" }[resp.genero];
      var m = { dia: "de día", noche: "de noche", todo: "para todos los días" }[resp.momento];
      var f = { dulce: "dulce y cálido", fresco: "fresco y limpio", intenso: "intenso y especiado" }[resp.familia];
      raiz.querySelector("#r-foto").src = mejor.img;
      raiz.querySelector("#r-foto").alt = mejor.alt;
      raiz.querySelector("#r-casa").textContent = mejor.casa;
      raiz.querySelector("#r-nombre").textContent = mejor.nombre;
      raiz.querySelector("#r-precio").textContent = mejor.precio.replace(".", ",") + " €";
      raiz.querySelector("#r-enlace").href = mejor.url;
      raiz.querySelector("#r-porque").innerHTML =
        "Buscas algo <b>" + g + "</b>, <b>" + m + "</b> y <b>" + f + "</b>. De la selección, este es el que mejor encaja: " + mejor.porque;
    }
    raiz.querySelectorAll(".opcion").forEach(function (b) {
      b.addEventListener("click", function () {
        resp[b.dataset.clave] = b.dataset.valor; paso++;
        if (paso === 3) recomienda();
        pinta();
        raiz.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });
    var re = raiz.querySelector("#reiniciar");
    if (re) re.addEventListener("click", function () { resp = {}; paso = 0; pinta(); });
  })();

  /* ---------- carrusel de selección ---------- */
  (function () {
    var carrusel = document.getElementById("parrilla");
    if (!carrusel) return;
    var sig = document.getElementById("parrilla-sig");
    if (sig) sig.addEventListener("click", function () {
      var t = carrusel.querySelector(".tarjeta");
      var paso = t ? t.getBoundingClientRect().width + 22 : 280;
      var alFinal = carrusel.scrollLeft + carrusel.clientWidth >= carrusel.scrollWidth - 10;
      carrusel.scrollTo({ left: alFinal ? 0 : carrusel.scrollLeft + paso, behavior: "smooth" });
    });
  })();

  /* ============================================================
     GALERÍA DE FICHA · miniaturas cambian la principal
     ============================================================ */
  (function () {
    var gal = document.querySelector(".pf-foto"); if (!gal) return;
    var principal = gal.querySelector("img"); if (!principal) return;
    document.querySelectorAll(".pf-mini [data-img]").forEach(function (mini) {
      mini.addEventListener("click", function () {
        var src = mini.getAttribute("data-img"); if (!src) return;
        principal.src = src;
        document.querySelectorAll(".pf-mini .activa").forEach(function (a) { a.classList.remove("activa"); });
        mini.classList.add("activa");
      });
    });
  })();

  /* ============================================================
     CARRITO AJAX real de Shopify
     ============================================================ */
  var Carrito = (function () {
    function pintaContador(n) {
      document.querySelectorAll("[data-cuenta-carrito]").forEach(function (el) {
        el.textContent = n;
        el.classList.toggle("vacio", n === 0);
      });
    }
    function refresca() {
      return fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) { pintaContador(c.item_count); return c; })
        .catch(function () { });
    }
    function anade(variantId, cantidad, boton) {
      if (!variantId) return;
      if (boton) { boton.classList.add("cargando"); boton.disabled = true; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: cantidad || 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
        .then(function () { return refresca(); })
        .then(function () { abre(); })
        .catch(function () {
          if (boton) { var t = boton.querySelector(".fx"); if (t) t.textContent = "Inténtalo de nuevo"; }
        })
        .finally(function () { if (boton) { boton.classList.remove("cargando"); boton.disabled = false; } });
    }
    var cajon = null;
    function abre() {
      cajon = document.getElementById("cajon-carrito");
      if (!cajon) { window.location.href = "/cart"; return; }
      pintaCajon();
      cajon.classList.add("abierto");
      document.body.style.overflow = "hidden";
    }
    function cierra() {
      if (cajon) { cajon.classList.remove("abierto"); document.body.style.overflow = ""; }
    }
    function pintaCajon() {
      var cuerpo = cajon.querySelector(".cajon-cuerpo");
      var pie = cajon.querySelector(".cajon-pie");
      cuerpo.innerHTML = '<p class="cajon-cargando">Cargando…</p>';
      fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c.items.length) {
            cuerpo.innerHTML = '<div class="cajon-vacio"><p>Tu carrito está vacío.</p><a class="btn btn-oro" href="/collections/all"><span class="fx">Ver el catálogo</span></a></div>';
            if (pie) pie.style.display = "none";
            return;
          }
          if (pie) pie.style.display = "";
          cuerpo.innerHTML = c.items.map(function (it, i) {
            return '<div class="cajon-item">'
              + '<img src="' + it.image + '" alt="" width="64" height="64">'
              + '<div class="cajon-item-info"><b>' + it.product_title + '</b>'
              + '<span>' + it.quantity + ' × ' + (it.price / 100).toFixed(2).replace(".", ",") + ' €</span></div>'
              + '<button type="button" class="cajon-quita" data-linea="' + (i + 1) + '" aria-label="Quitar">×</button>'
              + '</div>';
          }).join("");
          var total = cajon.querySelector(".cajon-total-num");
          if (total) total.textContent = (c.total_price / 100).toFixed(2).replace(".", ",") + " €";
          cuerpo.querySelectorAll(".cajon-quita").forEach(function (q) {
            q.addEventListener("click", function (e) {
              e.preventDefault();
              quita(q.getAttribute("data-linea"));
            });
          });
        });
    }
    function quita(linea) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: Number(linea), quantity: 0 })
      }).then(function () { pintaCajon(); refresca(); });
    }
    return { anade: anade, refresca: refresca, abre: abre, cierra: cierra };
  })();

  // formularios de producto
  document.querySelectorAll("form[data-form-producto]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var vid = form.querySelector("[name=id]");
      var qty = form.querySelector("[name=quantity]");
      Carrito.anade(vid && vid.value, qty ? Number(qty.value) : 1, form.querySelector("[type=submit]"));
    });
  });
  // abrir carrito desde la cabecera
  document.querySelectorAll("[data-abrir-carrito]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); Carrito.abre(); });
  });
  // cerrar cajón
  document.querySelectorAll("[data-cerrar-carrito]").forEach(function (b) {
    b.addEventListener("click", function () { Carrito.cierra(); });
  });
  Carrito.refresca();
  window.CAIROS.carrito = Carrito;

  /* ============================================================
     ASISTENTE CAIROS · motor de reglas sobre datos reales.
     Cero API, cero coste. Si no sabe, lleva a WhatsApp.
     ============================================================ */
  (function () {
    var boton = document.getElementById("ia-boton"), panel = document.getElementById("ia-panel");
    if (!boton || !panel) return;
    var cuerpo = panel.querySelector(".ia-cuerpo"),
      forma = panel.querySelector(".ia-forma"),
      input = panel.querySelector(".ia-forma input"),
      sugz = panel.querySelector(".ia-suger");
    var arrancado = false;

    function di(txt, quien) {
      var m = document.createElement("div");
      m.className = "ia-msg " + (quien || "bot");
      m.innerHTML = txt;
      cuerpo.appendChild(m);
      cuerpo.scrollTop = cuerpo.scrollHeight;
    }
    function pensando(cb) {
      var m = document.createElement("div");
      m.className = "ia-msg bot"; m.textContent = "…";
      cuerpo.appendChild(m); cuerpo.scrollTop = cuerpo.scrollHeight;
      setTimeout(function () { m.remove(); cb(); }, 420);
    }
    function norm(s) { return (s || "").toLowerCase().normalize("NFD").split("").filter(function (c) { var k = c.charCodeAt(0); return k < 768 || k > 879; }).join(""); }
    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

    function buscaPerfume(t) {
      return perfumes().find(function (p) { return norm(t).indexOf(norm(p.nombre)) >= 0; });
    }
    function fichaPerfume(p) {
      return "<b>" + p.nombre + "</b> (" + p.casa + "). " + cap(p.porque)
        + "<br>· Dura: " + p.duracion + " h · Estela: " + p.estela + "/5"
        + "<br>· " + p.precio.replace(".", ",") + " €"
        + '<br><a href="' + p.url + '">Ver la ficha completa →</a>';
    }
    function sugierePorFamilia(fam) {
      var l = perfumes().filter(function (p) { return p.familia === fam; }).slice(0, 3);
      if (!l.length) return "Cuéntame un poco más y te oriento.";
      var nombres = l.map(function (p) { return "<b>" + p.nombre + "</b>"; }).join(", ");
      var t = { dulce: "dulces y cálidos", fresco: "frescos y limpios", intenso: "intensos" }[fam];
      return "Para algo " + t + ", mira " + nombres + '. ¿Te digo cuál te pega mejor? Prueba <a href="#asesor">Encuentra tu firma</a>.';
    }
    function responde(t) {
      var q = norm(t);
      var p = buscaPerfume(t);
      if (p) return fichaPerfume(p);
      if (/(envio|envios|enviar|tarda|cuando llega|plazo|dias)/.test(q))
        return "Envío <b>gratis siempre</b>, sin mínimo. Sale desde Madrid y llega en <b>24-48 h</b>. Cada pedido lleva <b>2 muestras</b> elegidas a mano.";
      if (/(muestra|probar|prueba|tester)/.test(q))
        return "En cada pedido metemos <b>2 muestras gratis</b>, elegidas mirando lo que has comprado. Así lo pruebas en tu piel antes de decidir tu próximo frasco.";
      if (/(devolucion|devolver|reembolso|no me gusta)/.test(q))
        return "Si algo no encaja, escríbenos y lo resolvemos. Los perfumes van precintados; para eso están las muestras, para acertar sin riesgo.";
      if (/(original|autentic|falso|imitacion|garantia)/.test(q))
        return "Todos son <b>originales</b> (Lattafa, Armaf, Rasasi, Rayhaan…) comprados a distribuidor, con su caja y su precinto.";
      if (/(pago|pagar|tarjeta|bizum|contrareembolso)/.test(q))
        return "Puedes pagar con tarjeta de forma segura en el propio checkout. Si prefieres otra vía, dínoslo por WhatsApp y lo vemos.";
      if (/(cual|recomienda|no se cual|elegir|regalo|para mi|ayuda|aconseja)/.test(q))
        return 'Te lo afino en 3 preguntas: prueba <a href="#asesor">Encuentra tu firma</a>. O dime para quién es (él/ella/regalo), de día o de noche, y si lo quieres dulce, fresco o intenso.';
      if (/(dulce|vainilla|ambar|caramelo|gourmand)/.test(q)) return sugierePorFamilia("dulce");
      if (/(fresco|limpio|citric|acuatic|marino|verano)/.test(q)) return sugierePorFamilia("fresco");
      if (/(intenso|fuerte|especiad|noche|potente|oud)/.test(q)) return sugierePorFamilia("intenso");
      if (/(precio|barato|cuanto|caro)/.test(q))
        return "Tenemos frascos desde <b>20 €</b> hasta unos <b>50 €</b>, con envío incluido. ¿Te digo el de alguno en concreto?";
      if (/(hola|buenas|hey|que tal|holaa)/.test(q))
        return "¡Hola! Soy el asistente de CAIROS. Puedo ayudarte con notas y duración de cada perfume, envíos, muestras o a elegir cuál te pega. ¿Qué necesitas?";
      if (/(gracias|genial|perfecto|vale)/.test(q))
        return "A ti. Si quieres que lo vea una persona, te leemos al momento por WhatsApp 👇";
      return 'Buena pregunta — esa prefiero que te la conteste bien una persona. Escríbenos por <a href="' + WA + '" target="_blank" rel="noopener">WhatsApp</a> y te respondemos al momento.';
    }

    function abre() {
      panel.classList.add("abierto");
      if (!arrancado) {
        arrancado = true;
        di("¡Hola! 👋 Soy el asistente de <b>CAIROS</b>. Te ayudo a elegir perfume, o te resuelvo dudas de notas, duración y envíos.");
      }
    }
    boton.addEventListener("click", function () { panel.classList.contains("abierto") ? panel.classList.remove("abierto") : abre(); });
    var cerrar = panel.querySelector(".cerrar");
    if (cerrar) cerrar.addEventListener("click", function () { panel.classList.remove("abierto"); });

    forma.addEventListener("submit", function (e) {
      e.preventDefault();
      var t = input.value.trim(); if (!t) return;
      di(t, "yo"); input.value = "";
      pensando(function () { di(responde(t)); });
    });
    if (sugz) sugz.querySelectorAll(".ia-chip").forEach(function (c) {
      c.addEventListener("click", function () {
        di(c.textContent, "yo");
        pensando(function () { di(responde(c.textContent)); });
      });
    });
  })();

})();
